import { Immutable } from "immer";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { FormItem } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { CmsTournamentHighlightButton } from "@/gen/realtime";

import { FormControl, FormLabel } from "./shared";

export const TournamentHighlightButtonForm = ({
    block,
    setBlock,
}: {
    block: Immutable<CmsTournamentHighlightButton>;
    setBlock: (mutate: (block: CmsTournamentHighlightButton) => void) => void;
}) => {
    return (
        <div className="flex-grow space-y-6">
            <Card>
                <CardHeader>
                    <CardTitle>Tournament Highlight Button</CardTitle>
                </CardHeader>
                <CardContent className="space-y-6">
                    <FormItem>
                        <FormLabel className="text-md font-bold">Game ID</FormLabel>
                        <FormControl>
                            <Input
                                type="text"
                                placeholder="Enter game UUID..."
                                value={block.gameId}
                                onChange={e => {
                                    setBlock(block => {
                                        block.gameId = e.target.value;
                                    });
                                }}
                            />
                        </FormControl>
                        <p className="text-muted-foreground text-sm">
                            Enter a valid UUID for the game to highlight
                        </p>
                    </FormItem>
                </CardContent>
            </Card>
        </div>
    );
};
